import React from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  modifierCol,
  modifiedDateCol,
  utilityReqHeader,
  // unitHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

import { getMisoUser } from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { getApiTargetInfo, getUnitNameMap, getUtilityNameMap } from 'core'
import { connect } from 'react-redux'

const MisoUsers = ({ utilityNameMap, unitNameMap }) => {
  const headerWithFormatter = MisoUsersHeaders.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitId] || rowData.unitId,
        }
      : header
  )

  return (
    <CommonScreen
      title="Auto User Update Data"
      header={headerWithFormatter}
      retrieveTask={getMisoUser}
      altBy={d => d.username}
      autoRetrieve
      sortOptions={MisoUsersHeaders}
      widthOffset={50}
      onInsertEvent={_ => false}
      withoutModify
      withDelete={false}
      allowInsert={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(MisoUsers)

const MisoUsersHeaders = [
  strCol({
    ident: 'username',
    display: 'Username',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({ ident: 'first', display: 'First', isFiltered: true, width: 200 }),
  strCol({ ident: 'last', display: 'Last', isFiltered: true, width: 200 }),
  utilityReqHeader,
  unitIdHeader,
  strCol({
    ident: 'accesstype',
    display: 'Access Type',
    isKey: true,
    width: 200,
  }),

  modifierCol,
  modifiedDateCol,
]
